import {
  CoveragePlanCardUrl,
  CoveragePlanSummary,
  CoveragePlanType,
  Language
} from '@cms-max/medicare-api-sdk'
import { rest } from 'msw'
import { isTest } from 'test-utils/isTest'
import { coreApiBase } from './coreApiBase'

const defaultPlanSummary: CoveragePlanSummary = {
  hasPartA: true,
  hasPartB: true,
  isMedicareAdvantage: false,
  isImmunosuppressiveDrugCoverage: false,
  isTerminated: false
}

const urlEn: CoveragePlanCardUrl = {
  language: Language.En,
  url: 'https://medicare.gov/url-en'
}
const urlEs: CoveragePlanCardUrl = {
  language: Language.Es,
  url: 'https://medicare.gov/url-es'
}

export const planMap = {
  partA: {
    type: CoveragePlanType.OmPartA,
    title: 'Original Medicare',
    name: 'Hospital Insurance (Part A)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    urls: [urlEn, urlEs]
  },
  partB: {
    type: CoveragePlanType.OmPartB,
    title: 'Original Medicare',
    name: 'Medical Insurance (Part B)',
    active: true,
    enrollment_effective_date: '2019-08-12',
    urls: [urlEn, urlEs]
  },
  ma: {
    type: CoveragePlanType.Ma,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2016-05-01',
    urls: [urlEn, urlEs]
  },
  mapd: {
    type: CoveragePlanType.Mapd,
    title: 'Medicare Advantage Plan',
    name: 'Alterwood Advantage Select (HMO)',
    active: true,
    enrollment_effective_date: '2016-05-01',
    urls: [urlEn, urlEs]
  },
  partD: {
    type: CoveragePlanType.Pdp,
    title: 'Drug Insurance (Part D)',
    name: 'Elixir RxSecure (PDP)',
    active: true,
    enrollment_effective_date: '2022-01-01',
    urls: [urlEn, urlEs]
  },
  pbid: {
    type: CoveragePlanType.Pbid,
    title: 'Immunosuppressive drugs (Part B)',
    name: 'Immuno Drug Only',
    active: true,
    enrollment_effective_date: '2022-01-01',
    urls: [urlEn, urlEs]
  },
  other: {
    type: CoveragePlanType.Pdp,
    title: 'Other Insurance',
    name: 'Aetna Retiree Plan',
    active: true,
    enrollment_effective_date: '2012-02-01',
    urls: [urlEn, urlEs]
  }
}

export function plansSuccess (
  items: Array<keyof typeof planMap> = [],
  summary: Partial<CoveragePlanSummary> = {}
) {
  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(
      ctx.delay(isTest ? 0 : undefined),
      ctx.status(200),
      ctx.json({
        summary: {
          ...defaultPlanSummary,
          ...summary
        },
        plans: items.map((item) => planMap[item])
      })
    )
  })
}

type plansLoadingOpts = {
  items?: Array<keyof typeof planMap>
  summary?: CoveragePlanSummary
  ttl?: number
}
export function plansLoading (opts?: plansLoadingOpts) {
  const { items = [], summary = defaultPlanSummary, ttl = 10000 } = opts || {}

  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(
      ctx.delay(ttl),
      ctx.status(200),
      ctx.json({
        summary,
        plans: items.map((item) => planMap[item])
      })
    )
  })
}

export function plansError () {
  return rest.get(`${coreApiBase}/plans`, (req, res, ctx) => {
    return res(ctx.delay(isTest ? 0 : undefined), ctx.status(500), ctx.json({}))
  })
}
